module.exports = __webpack_public_path__ + "img/孜然.c15c0aec.jpg";